import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { APP_BASE } from './config/base';
import { inShell, inFrame, bootShell, shellRedirectTarget } from './shell';
import { startFrame } from './frame';
import { standalone, bootStandalone, whenStuck } from './standalone';
import StandaloneNotice from './components/auth/StandaloneNotice';

let root = null;
const rootEl = () => root || (root = ReactDOM.createRoot(document.getElementById('root')));

// Hiring's own app, when signing in cannot complete: a message and Try
// again, never a form.
function renderNotice(message) {
  rootEl().render(<StandaloneNotice message={message} />);
}

function render() {
  rootEl().render(
    <BrowserRouter
      basename={APP_BASE || undefined}
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <App />
    </BrowserRouter>
  );
}

// A staff screen opened top level on a campus address belongs in the shell.
const toShell = shellRedirectTarget();
if (toShell) {
  window.location.replace(toShell);
} else if (inFrame) {
  // Hiring's own address: the EquaOS frame, as People and every other app.
  startFrame().catch(() => renderNotice('Hiring could not start. Reload the page to try again.'));
} else if (inShell) {
  // Take the session from the shell before any screen reads it.
  bootShell().finally(render);
} else if (standalone) {
  // hiring.<school>.equaos.in: the session from the school's one sign-in.
  whenStuck(renderNotice);
  bootStandalone()
    .then((message) => (message ? renderNotice(message) : render()))
    .catch(() => renderNotice('Hiring could not start. Reload the page to try again.'));
} else {
  render();
}
